var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99967 18.6667L25.9997 16L27.333 8H7.33301M9.99967 18.6667L7.33301 8M9.99967 18.6667V21.3333H25.9997M7.33301 8L5.99967 4H3.33301M11.333 26C11.333 27.1053 10.4383 28 9.33301 28C8.22767 28 7.33301 27.1053 7.33301 26C7.33301 24.8947 8.22767 24 9.33301 24C10.4383 24 11.333 24.8947 11.333 26ZM27.333 26C27.333 27.1053 26.4383 28 25.333 28C24.2277 28 23.333 27.1053 23.333 26C23.333 24.8947 24.2277 24 25.333 24C26.4383 24 27.333 24.8947 27.333 26Z",
    stroke: "#212B33",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cart-icon.746537bed1bac700a3f74836e761f443.svg";
export { ForwardRef as ReactComponent };